// @flow
export default {
  tooltip: 100,
};
